'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.appstore.add', [])
  .controller('AppStoreAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appstore/add/index.js